
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import Nav from './components/nav/Nav'
import ScaleViewer from './pages/scale-viewer/ScaleViewer';
import ScaleFinder from './pages/scale-finder/ScaleFinder';
import Footer from './components/footer/footer';

function App() {
  

  return (
    <Router>
      <div className="App">
        <Nav></Nav>
        <main className='main-content'>
        <Routes>
          <Route path='/' element={<ScaleViewer />} />
          <Route path='/scale-finder' element={<ScaleFinder />} />
        </Routes>
        </main>
        <Footer />
      </div>

    </Router>
  );
}

export default App;
